import { UsersApi } from "@/api/users";
import { GetFeatureFlagByNameRequest } from "@/api/users/types";
import { QueryKey } from "@/utils";
import { useQuery } from "@tanstack/react-query";

export const useGetUserFeatureFlag = (reqArgs: GetFeatureFlagByNameRequest) => {
  const { data, isError, isPending } = useQuery({
    queryKey: [QueryKey.FEATURE_FLAG, reqArgs.name],
    queryFn: () => UsersApi.getFeatureFlagByName(reqArgs),
    enabled: !!reqArgs,
    select: ({ enabled }) => enabled,
  });

  return {
    featureFlag: data,
    getUserFeatureFlagError: isError,
    isGetUserFeatureFlagLoading: isPending,
  };
};
